import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  FormGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import React from "react";
import Checkbox from "@mui/material/Checkbox";

const TaskScheduleCard = ({ task, onSave, extraFields }) => {
  const {
    name,
    schedule: { hour, minute },
    enabled,
  } = task;

  const extraInitial = {};
  if (extraFields) {
    extraFields.forEach((f) => { extraInitial[f.key] = task[f.key]; });
  }

  return (
    <FormGroup>
      <Formik
        initialValues={{ hour, minute, enabled, ...extraInitial }}
        enableReinitialize
        onSubmit={async (values, { setSubmitting }) => {
          try {
            await onSave(values);
          } catch (e) {
            console.error("Failed to save schedule:", e);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ handleChange, handleSubmit, values, isValid, dirty, isSubmitting }) => (
          <Card variant="outlined">
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "primary.main" }}>{name}</Typography>
                <Checkbox
                  checked={values.enabled}
                  onChange={handleChange("enabled")}
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                <Tooltip title="Hour of day in UTC (0-23)">
                  <TextField
                    sx={{ maxWidth: 100 }}
                    onChange={handleChange("hour")}
                    value={values.hour}
                    variant="outlined"
                    type="number"
                    label="Hour"
                    size="small"
                    InputProps={{ inputProps: { min: 0, max: 23 } }}
                  />
                </Tooltip>

                <Tooltip title="Minute of the hour (0-59)">
                  <TextField
                    sx={{ maxWidth: 100 }}
                    onChange={handleChange("minute")}
                    value={values.minute}
                    variant="outlined"
                    type="number"
                    label="Minute"
                    size="small"
                    InputProps={{ inputProps: { min: 0, max: 59 } }}
                  />
                </Tooltip>

                {extraFields?.map((f) => (
                  <Tooltip key={f.key} title={f.tooltip}>
                    <TextField
                      sx={{ maxWidth: f.maxWidth || 120 }}
                      onChange={handleChange(f.key)}
                      value={values[f.key]}
                      variant="outlined"
                      type="number"
                      label={f.label}
                      size="small"
                      InputProps={{ inputProps: f.inputProps }}
                    />
                  </Tooltip>
                ))}
              </Box>
            </CardContent>
            <CardActions>
              <Button
                sx={{ ml: 1 }}
                variant="contained"
                size="small"
                onClick={handleSubmit}
                disabled={!isValid || !dirty || isSubmitting}
              >
                Apply
              </Button>
            </CardActions>
          </Card>
        )}
      </Formik>
    </FormGroup>
  );
};

export default TaskScheduleCard;
